import styles from './ProtectedRoute.module.scss';
import { useMeQuery } from '@customer/store/apis/authApi';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@customer/store/hooks';
import { Permission, userHasPermission } from '@customer/permissions';
import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';
import WelcomeInjector from '@customer/dialogs/welcome-modal/WelcomeInjector';
import { ProgressIndicatorCircular } from '@dmc/ui';

export interface ProtectedRouteProps {
  permission?: Permission;
  paywall?: ReactNode;
  children: JSX.Element;
}

export default function ProtectedRoute(props: ProtectedRouteProps) {
  const { t } = useTranslation();

  // useMeQuery only used to trigger redirections
  useMeQuery();
  const userData = useAppSelector(state => state.auth);

  const permission = props.permission ?? Permission.CanAccess;

  if (userData.isMaintenance) {
    return (
      <div className={styles.loadingPanel}>
        <span>{t('maintenance')}</span>
      </div>
    );
  }

  if (userData.isRedirecting) {
    return (
      <div className={styles.loadingPanel}>
        <ProgressIndicatorCircular />
        <span>{userData.actionLoggingIn ? t('Logging in') : t('Logging out')}</span>
      </div>
    );
  }

  if (userHasPermission(userData, permission)) {
    return <WelcomeInjector>{props.children}</WelcomeInjector>;
  }

  if (typeof props.paywall !== 'undefined' && userHasPermission(userData, Permission.CanAccess)) {
    return <WelcomeInjector>{props.paywall}</WelcomeInjector>;
  }

  return <Navigate to="/no-access" replace />;
}
